import Laying from '@assets/svg/laying.svg'
import Strolling from '@assets/svg/strolling.svg'
import { Button, Modal } from '@hub/shared'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import './modal-payment-onboarding.component.scoped.scss'
import './modal-payment-onboarding.component.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  openModal: boolean
  setOpenModal: (event: any) => any
}

export default ({ openModal, setOpenModal }: Props) => {
  const [t] = useTranslation('modalPaymentOnboarding')

  const [activeTab, setActiveTab] = useState(0)

  let modalContent = (
    <div className="content">
      <img src={Strolling} alt="strolling" title="strolling" className="img-fluid mb-5" />
      <h5>{t('letsgo')}</h5>
      <p>{t('explanatoryText')}</p>
    </div>
  )
  if (activeTab === 1) {
    modalContent = (
      <div className="content">
        <img src={Laying} alt="laying" title="laying" className="img-fluid mb-5" />
        <h5>{t('letsgo')}</h5>
        <p>{t('corretDataText')}</p>
      </div>
    )
  }

  return (
    <Modal
      className="modal-payment-onboarding"
      open={openModal}
      modalSize="md"
      forceMobileNoMargin
      onCloseChange={() => setOpenModal(false)}
      header={<h5 style={{ margin: 0, height: 25 }}>{t('title')}</h5>}
      footer={
        <div className="menu-modal col-24 display-flex justify-content-space-between">
          <Button
            onClick={() => (activeTab === 1 ? setActiveTab(0) : setOpenModal(false))}
            id="cancel-button-navigation-modal"
            color="transparent"
            textColor={activeTab === 0 ? 'var(--primary_color)' : 'var(--text_color)'}
            borderColor="var(--primary_color)"
            borderStyle={activeTab === 1 ? 'none' : ''}
          >
            <span className="text-button" style={{ whiteSpace: 'nowrap', display: 'inline-block', width: '100%' }}>
              {activeTab === 0 ? t('skip') : t('back')}
            </span>
          </Button>
          <Button
            onClick={() => (activeTab === 0 ? setActiveTab(1) : setOpenModal(false))}
            id="confirm-button-navigation-modal"
            className="confirm-button-navigation"
          >
            <span className="text-button" style={{ whiteSpace: 'nowrap', display: 'inline-block', width: '100%' }}>
              {activeTab === 0 ? t('next') : t('confirm')}
            </span>
          </Button>
        </div>
      }
    >
      <div
        className={`display-flex align-items-center justify-content-center scrollbar ${window?.innerWidth > 767 ? 'my-5' : null}`}
        style={{ width: '100%', height: window?.innerWidth < 768 ? `calc(${window?.innerHeight}px - 67px - 53px)` : '' }}
      >
        {modalContent}
      </div>
    </Modal>
  )
}
